import { Space } from 'antd';
import { IconButton } from '../../../../components/IconButton';
import { EditIcon } from '../../../../assets/icons/EditIcon';
import { BonusCatalog } from '../../../../lib/types/bonusCatalog';
import { ModalActions } from '../../../../lib/models/Modal';
import { setCurrentBonusCatalog, setModalOpened } from '../../../../lib/store/slices/bonusCatalogSlice';
import { useAppDispatch } from '../../../../lib/store/hooks';
import { ActionsDropdown } from '../../../../components/Table/ActionsDropdown/ActionsDropdown';

export const BonusCatalogActionsBodyCell = ({ row }: any) => {
  const dispatch = useAppDispatch();

  const onEditBonusCatalog = (bonusCatalog: BonusCatalog) => () => {
    dispatch(setCurrentBonusCatalog(bonusCatalog));
    dispatch(setModalOpened(ModalActions.EDIT));
  };

  return (
    <Space size="middle">
      <IconButton icon={<EditIcon />} onClick={onEditBonusCatalog(row)} />
      <ActionsDropdown table="bonuses" row={row} />
    </Space>
  );
};
